"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_router_1 = require("vue-router");
const qs_1 = __importDefault(require("qs"));
const dashboard_1 = __importDefault(require("./paths/dashboard"));
const security_1 = __importDefault(require("./paths/security"));
const shop_1 = __importDefault(require("./paths/shop"));
const admin_1 = __importDefault(require("./paths/admin"));
const queries_1 = __importDefault(require("./paths/queries"));
const registrationPage_1 = __importDefault(require("./paths/registrationPage"));
const axapta_1 = __importDefault(require("./paths/axapta"));
const news_1 = __importDefault(require("./paths/news"));
const productReturn_1 = __importDefault(require("./paths/productReturn"));
const informationPage_1 = __importDefault(require("./paths/informationPage"));
const contents_1 = __importDefault(require("./paths/contents"));
const pricing_1 = __importDefault(require("./paths/pricing"));
const customDesign_1 = __importDefault(require("./paths/customDesign"));
const quotation_1 = __importDefault(require("./paths/quotation"));
const banner_1 = __importDefault(require("./paths/banner"));
exports.default = (0, vue_router_1.createRouter)({
    history: (0, vue_router_1.createWebHistory)(),
    routes: [
        ...security_1.default,
        ...dashboard_1.default,
        ...shop_1.default,
        ...admin_1.default,
        ...queries_1.default,
        ...registrationPage_1.default,
        ...axapta_1.default,
        ...news_1.default,
        ...productReturn_1.default,
        ...informationPage_1.default,
        ...contents_1.default,
        ...pricing_1.default,
        ...customDesign_1.default,
        ...quotation_1.default,
        ...banner_1.default
    ],
    // @ts-ignore
    parseQuery: qs_1.default.parse,
    stringifyQuery: (query) => {
        return qs_1.default.stringify(query, { encodeValuesOnly: true });
    },
    scrollBehavior() {
        return { top: 0 };
    }
});
